<template>
  <div v-if="loading" class="loading-spinner" :class="size">
    <img src="../assets/spinner.svg">
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    loading : false,
    size: {
      type: String,
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@use "@/scss/mixins.scss";
@use "@/scss/variables.scss";
@import "../scss/styles.scss";

.loading-spinner {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  grid-column: 1 / -1;
  img{
    width: 6rem;
  }
  &.page{
    min-height: 80vh;
    img{
      width: 4rem;
      @include bp(sm){
        width: 7rem;
      }
    }
  }
  &.component{
    height: 100%;
    img{
      width: 5rem;
    }
  }
  &.small{
    img{
      width: 4rem;
    }
  }
}

</style>
